// extracted by mini-css-extract-plugin
module.exports = {"quote":"index-module--quote--3r5j6","cite":"index-module--cite--RlgzV","person":"index-module--person--2lW1H","class":"index-module--class--3CttJ"};